import { createApi } from '@reduxjs/toolkit/query/react';
import { serviceBaseQuery } from './baseQuery';

export const apiTagTypes = [
    'Driver',
    'DriverList',
    'User',
    'UserList',
    'Tag',
    'TagList',
    'Group',
    'GroupList',
] as const;

export const baseApi = createApi({
    reducerPath: 'api',
    baseQuery: serviceBaseQuery,
    tagTypes: apiTagTypes,
    endpoints: () => ({}),
});
